'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { InstantSearch, Configure } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { ALGOLIA_INDEX_NAME, NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import AdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/AdvancedSearchContext';
import { useTransition } from 'components/consumer/consumer-search/advanced-search-next/hooks/reactShims';
import useProductListingProductsOnDisplay from 'hooks/useProductListingData/useProductListingProductsOnDisplay';
import ShowroomDisplayContext from './hooks/ShowroomDisplayContext';
import CategoryAlgoliaLayout from './components/CategoryAlgoliaLayout';
import useCategoryPageURL from './hooks/useCategoryPageURL';
const CategoryPageAlgolia = t0 => {
  const $ = _c(51);
  const {
    slug,
    serverCategoryData
  } = t0;
  const [currentProductIndex, setCurrentProductIndex] = useState(ALGOLIA_INDEX_NAME.PRODUCTS);
  const [isReadyToShipActive, setIsReadyToShipActive] = useState(false);
  const [minWidth, setMinWidth] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedColors, setSelectedColors] = useState(t1);
  const [, startTransition] = useTransition();
  const showroomData = useProductListingProductsOnDisplay();
  let t2;
  if ($[1] !== startTransition) {
    t2 = indexName => {
      startTransition(() => {
        setCurrentProductIndex(indexName);
      });
    };
    $[1] = startTransition;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateCurrentProductIndex = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = checked => {
      setIsReadyToShipActive(checked);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleToggleReadyToShip = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (min, max) => {
      setMinWidth(min);
      setMaxWidth(max);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleWidthChange = t4;
  let t5;
  if ($[5] !== selectedColors) {
    t5 = colorLabel => {
      const isSelected = !!selectedColors?.[colorLabel];
      setSelectedColors(prev => ({
        ...prev,
        [colorLabel]: !isSelected
      }));
    };
    $[5] = selectedColors;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const selectColor = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setSelectedColors({});
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const clearSelectedColors = t6;
  const [activeTypeFilter, setActiveTypeFilter] = useState(null);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const [selectedFacets, setSelectedFacets] = useState(t7);
  const {
    pagesUrlParam,
    updateUrlParamImmediate
  } = useCategoryPageURL(slug);
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = (attribute, value) => {
      setSelectedFacets(prev_0 => {
        const current = prev_0[attribute] || new Set();
        const next = new Set(current);
        if (next.has(value)) {
          next.delete(value);
        } else {
          next.add(value);
        }
        const result = {
          ...prev_0
        };
        if (next.size === 0) {
          delete result[attribute];
        } else {
          result[attribute] = next;
        }
        return result;
      });
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const handleToggleFacet = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setSelectedFacets({});
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const clearSelectedFacets = t9;
  let t10;
  if ($[11] !== activeTypeFilter || $[12] !== currentProductIndex || $[13] !== isReadyToShipActive || $[14] !== maxWidth || $[15] !== minWidth || $[16] !== pagesUrlParam || $[17] !== selectColor || $[18] !== selectedColors || $[19] !== selectedFacets || $[20] !== updateCurrentProductIndex || $[21] !== updateUrlParamImmediate) {
    t10 = {
      currentSearchSection: ALGOLIA_INDEX_NAME.PRODUCTS,
      currentProductIndex,
      updateSearchSection: _temp,
      updateCurrentProductIndex,
      isReadyToShipActive,
      handleToggleReadyToShip,
      minWidth,
      maxWidth,
      handleWidthChange,
      selectedColors,
      selectColor,
      clearSelectedColors,
      pagesUrlParam,
      activeTypeFilter,
      setActiveTypeFilter,
      updateUrlParamImmediate,
      selectedFacets,
      clearSelectedFacets
    };
    $[11] = activeTypeFilter;
    $[12] = currentProductIndex;
    $[13] = isReadyToShipActive;
    $[14] = maxWidth;
    $[15] = minWidth;
    $[16] = pagesUrlParam;
    $[17] = selectColor;
    $[18] = selectedColors;
    $[19] = selectedFacets;
    $[20] = updateCurrentProductIndex;
    $[21] = updateUrlParamImmediate;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const context = t10;
  const t11 = `categories:${slug}`;
  let filters;
  if ($[23] !== isReadyToShipActive || $[24] !== selectedFacets || $[25] !== t11) {
    filters = [t11];
    if (isReadyToShipActive) {
      filters.push("is_in_stock:true");
    }
    Object.entries(selectedFacets).forEach(t12 => {
      const [attr, values] = t12;
      if (values.size > 0) {
        filters.push([...values].map(v => `${attr}:${v}`));
      }
    });
    $[23] = isReadyToShipActive;
    $[24] = selectedFacets;
    $[25] = t11;
    $[26] = filters;
  } else {
    filters = $[26];
  }
  const facetFilters = filters;
  let filters_0;
  if ($[27] !== maxWidth || $[28] !== minWidth) {
    filters_0 = ["item_availability=0", "visibility>1", "visibility<4"];
    const minNum = parseInt(minWidth, 10);
    const maxNum = parseInt(maxWidth, 10);
    if (!Number.isNaN(minNum) && minNum >= 1) {
      filters_0.push(`item_width>=${minNum}`);
    }
    if (!Number.isNaN(maxNum) && maxNum <= 300) {
      filters_0.push(`item_width<=${maxNum}`);
    }
    $[27] = maxWidth;
    $[28] = minWidth;
    $[29] = filters_0;
  } else {
    filters_0 = $[29];
  }
  const numericFilters = filters_0;
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      preserveSharedStateOnUnmount: true
    };
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["*"];
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["_highlightResult", "product_id", "name", "is_in_stock"];
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== facetFilters || $[34] !== numericFilters) {
    t15 = <Configure facets={t13} facetFilters={facetFilters} numericFilters={numericFilters} hitsPerPage={NUMBER_OF_PRODUCTS_TO_SHOW} attributesToRetrieve={t14} clickAnalytics={true} />;
    $[33] = facetFilters;
    $[34] = numericFilters;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== facetFilters || $[37] !== selectedFacets || $[38] !== serverCategoryData || $[39] !== slug) {
    t16 = <CategoryAlgoliaLayout slug={slug} serverCategoryData={serverCategoryData} facetFilters={facetFilters} selectedFacets={selectedFacets} onToggleFacet={handleToggleFacet} onClearFacets={clearSelectedFacets} />;
    $[36] = facetFilters;
    $[37] = selectedFacets;
    $[38] = serverCategoryData;
    $[39] = slug;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== currentProductIndex || $[42] !== t15 || $[43] !== t16) {
    t17 = <InstantSearch searchClient={searchClient} indexName={currentProductIndex} future={t12}>{t15}{t16}</InstantSearch>;
    $[41] = currentProductIndex;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== showroomData || $[46] !== t17) {
    t18 = <ShowroomDisplayContext.Provider value={showroomData}>{t17}</ShowroomDisplayContext.Provider>;
    $[45] = showroomData;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== context || $[49] !== t18) {
    t19 = <AdvancedSearchContext.Provider value={context}>{t18}</AdvancedSearchContext.Provider>;
    $[48] = context;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  return t19;
};
CategoryPageAlgolia.propTypes = {
  slug: PropTypes.string.isRequired,
  serverCategoryData: PropTypes.object
};
export default CategoryPageAlgolia;
function _temp() {}